module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8yiui"))).then(() => parcelRequire('hEqeo'));